module.exports = __webpack_public_path__ + "img/fontawesome-webfont.eot?674f50d287a8c48dc19ba404d20fe713";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/font-awesome/fonts/fontawesome-webfont.eot
// module id = 594
// module chunks = 0